/* import __COLOCATED_TEMPLATE__ from './atm-limits.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { GetCardAtmLimitsRequest, GetCardAtmLimitsResponse } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/card/card_service';
import { createLimits } from './atm-limits-util';
const {
  DAILY,
  WEEKLY,
  MONTHLY,
  PER_TRANSACTION
} = GetCardAtmLimitsResponse.Cadence;
let AtmLimits = (_dec = service('bbfrontend/v1/card'), _class = class AtmLimits extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "bbFrontendV1CardService", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _initializerDefineProperty(this, "sentry", _descriptor5, this);
    _initializerDefineProperty(this, "formatter", _descriptor6, this);
    _initializerDefineProperty(this, "localeTime", _descriptor7, this);
    _initializerDefineProperty(this, "loading", _descriptor8, this);
    _initializerDefineProperty(this, "isError", _descriptor9, this);
    _initializerDefineProperty(this, "transactionLimit", _descriptor10, this);
    _initializerDefineProperty(this, "limits", _descriptor11, this);
    _defineProperty(this, "setLimits", limits => {
      // there must be 4 types of limit, DAILY, WEEKLY, MONTHLY and PER_TRANSACTION.
      if (limits.length !== 4) {
        this.isError = true;
        this.sentry.captureException('GetCardAtmLimitsResponse must have exactly 4 limits');
        return;
      }
      const cadencesLimits = createLimits(limits, this.intl, this.formatter, this.localeTime);
      this.transactionLimit = cadencesLimits[PER_TRANSACTION].limit;
      this.limits = [DAILY, WEEKLY, MONTHLY].map(limit => cadencesLimits[limit]);
    });
  }
  async initialize() {
    try {
      const response = await this.bbFrontendV1CardService.client.getCardAtmLimits(GetCardAtmLimitsRequest.create({
        cardToken: this.args.cardToken
      }));
      this.setLimits(response.limits);
    } catch (error) {
      this.isError = true;
      this.sentry.captureException(error);
    }
    this.loading = false;
  }
  done() {
    this.args.dismiss();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CardService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "localeTime", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "transactionLimit", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "limits", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "initialize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "done", [action], Object.getOwnPropertyDescriptor(_class.prototype, "done"), _class.prototype), _class);
export { AtmLimits as default };